// The token is a live credential, so it must never reach a log store.
export const maskToken = (url: string) => url.replace(/token=[^&]*/, 'token=[Filtered]');
